import React from "react";
import Icon from 'jitsi/base/icons/components/Icon';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme, color) => ({
    container: {
        backgroundColor: theme.palette[color],
        borderRadius: theme.shape.borderRadius,
        marginRight: theme.spacing(2),
        padding: theme.spacing(2),
        aspectRatio: "1",
    },
}));
export const AttachmentIcon = ({ icon, color }) => {
    const { classes } = useStyles(color);
    return (React.createElement("div", { className: classes.container },
        React.createElement(Icon, { colorInClass: true, src: icon, size: 20 })));
};
